import { createSlice } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";

type ApproverState = CommonTableState;

const initialState: ApproverState = {
    tableState: {
        resetIndicator: 0,
        sorting: [{ id: "licence.company.id", desc: false }],
        columnPinning: {
            right: ["mrt-row-actions"],
        },
        columnOrder: ["licence.company.id", "user.person.id", "user.id", "creator", "created", "mrt-row-actions"],
        columnVisibility: {
        },
        density: "compact",
    },
};

export const approverSlice = createSlice({
    name: "approver",
    initialState: initialState,
    reducers: {
        updateApproverTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
    },
});

// Action creators are generated for each case reducer function
export const { updateApproverTableState } = approverSlice.actions;

export default approverSlice.reducer;
